import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import { getImgAltText } from 'utils/alt-attribute-helper';

class CarouselSliderImage extends Component
{
    constructor(props)
    {
        super(props);
        this.setValue = this.setValue.bind(this);
        this.state = {
            changedIndex: props.selectedImageIndex,
        };
    }


    setValue(index)
    {
        this.setState({ changedIndex: index });
    }


    renderArrowPrev(clickHandler)
    {
        return (<div className="carousel-arrow-container left fixed-pos"><button type="button" className="carousel-arrow" aria-label="Left Arrow" onClick={clickHandler}></button></div>);
    }

    renderArrowNext(clickHandler)
    {
        return (<div className="carousel-arrow-container right fixed-pos"><button type="button" className="carousel-arrow" aria-label="Right Arrow" onClick={clickHandler}></button></div>);
    }

    render()
    {
        const {
            images, element,
        } = this.props;

        return (
            <Carousel showArrows onChange={this.setValue} selectedItem={this.state.changedIndex} onClickItem={this.setValue} showIndicators={false} showStatus={false} renderArrowPrev={this.renderArrowPrev} renderArrowNext={this.renderArrowNext} preventMovementUntilSwipeScrollTolerance swipeScrollTolerance={20}>
                {images.map(image => (
                    <div className="carousel-vertical-center" key={image.id}>
                        <img loading="lazy" src={image.path} alt={getImgAltText(element)} />
                    </div>
                ))}
            </Carousel>
        );
    }
}

CarouselSliderImage.propTypes = {
    images: PropTypes.array.isRequired,
    element: PropTypes.string.isRequired,
    selectedImageIndex: PropTypes.number,
};

export default CarouselSliderImage;
